import Cookies from "universal-cookie";

export class utilities {
  static ConvertToString(input: string[]): string {
    let list: string = "";
    let comma: boolean = false;
    input.forEach(function (value) {
      if (comma) {
        list = list + ",";
      }

      comma = true;

      list = list + value;
    });

    return list;
  }

  static newGuid(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
      c
    ) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  static GetPrimaryColor(): string {
    const cookies = new Cookies();
    let primaryColor = cookies.get("primaryColor");
    if (!primaryColor) primaryColor = "#3B5999";
    return primaryColor;
  }

  static GetSecondaryColor(): string {
    const cookies = new Cookies();
    return cookies.get("secondaryColor");
  }

  static GetMemberId(): string {
    const cookies = new Cookies();
    return cookies.get("memberId");
  }

  static GetCookieValue(key:string):string{
    const cookies = new Cookies();
    return cookies.get(key);    
  }

  static GetAllCookieValues(): { index: string } {
    const cookies = new Cookies();
    return cookies.getAll();
  }

  static SetCookieValue(key:string, value:string){
    const cookies = new Cookies();
    cookies.set(key, value);
  }

  static RemoveCookieValue(key:string){
    const cookies = new Cookies();
    cookies.remove(key);
  }

  static RemoveAllCookies(){
    const cookies = new Cookies();
    const allCookies = cookies.getAll();
    Object.keys(allCookies)      
      .forEach(c => cookies.remove(c));
  }
}
